import { isEmpty, omitBy } from 'lodash';
import qs from 'qs';

import Endpoint from '@ad-scripts/adapters/gateways/lib/standard_gateway/endpoint';
import StandardGateway from '@ad-scripts/adapters/gateways/lib/standard_gateway';

const PROMOTE_REQUEST_TIMEOUT = 30000;

/**
 * Ivrs Gateway
 */
export default class IvrsGateway extends StandardGateway {
  constructor(backend, url = 'v1/orgs/:orgId/configuration/ivrs/:id') {
    const endpoint = new Endpoint(url);
    endpoint.patterns.broadcastTopic = 'v1/orgs/:orgId/configuration/ivrs';
    endpoint.patterns.collectionBroadcastTopic = 'v1/orgs/:orgId/configuration/ivrs/+';

    super(backend, endpoint.patterns);
  }

  buildUrl(path, queryParams) {
    // Remove `undefined` and `NaN` param values
    const search = omitBy(queryParams, v => v === undefined || v !== v);
    const join = path.includes('?') ? '&' : '?';

    return isEmpty(search) ? path : `${path}${join}${qs.stringify(search, { arrayFormat: 'repeat' })}`;
  }

  fetchVersion(params) {
    const url = this.endpoint.set(params).fetchUrl;
    return this.http
      .get(`${url}/versions/${params.version}`)
      .then(dto => {
        this.observer.onFetchSuccess(dto, params);
        return dto;
      })
      .catch(error => {
        this.observer.onFetchError(error, params);
        throw error;
      });
  }

  addIvr(data) {
    let url = this.endpoint.addUrl;
    return this.http.post(`${url}`, data).catch(error => this.observer.onAddError(error, {}));
  }

  addVersion(params, data) {
    let url = this.endpoint.set(params).addUrl;
    return this.http
      .post(`${url}/${params.id}/versions/${params.version}`, data || params)
      .then(dto => this.observer.onAddSuccess(dto, params))
      .catch(error => this.observer.onAddError(error, params));
  }

  promote(params, data) {
    const url = this.endpoint.set(params).updateUrl;
    return this.http
      .post(`${url}/versions/${params.version}/promote`, data, { timeout: PROMOTE_REQUEST_TIMEOUT })
      .then(dto => this.observer.onUpdateSuccess(dto, params))
      .catch(error => this.observer.onUpdateError(error, params));
  }

  restore(params, data) {
    let url = this.endpoint.set(params).addUrl;
    return this.http
      .post(`${url}/${params.id}/versions/${params.version}/restore`, data)
      .then(dto => this.observer.onAddSuccess(dto, params))
      .catch(error => this.observer.onAddError(error, params));
  }

  makePhoneCall(params, phoneNumber) {
    const url = this.endpoint.set(params).updateUrl;
    return this.http
      .post(`${url}/versions/${params.version}/preview`, { phoneNumber })
      .then(dto => this.observer.onUpdateSuccess(dto, params))
      .catch(error => this.observer.onUpdateError(error, params));
  }
}
